<template>
    <Transition name="recap-dialog-transition" @after-enter="handleOpenModal">
        <div v-if="visible" class="recap-dialog">
            <div
                v-show="visible"
                ref="overlay"
                class="recap-dialog__overlay"
                tabindex="-1"
                @click.self="handleCloseDialog(true)"
                @keydown.esc="handleCloseDialog"
            >
                <Transition name="recap-dialog-modal-transition" @after-leave="handleCloseDialog">
                    <div
                        v-show="localValue"
                        ref="modal"
                        class="recap-dialog__modal"
                        tabindex="-1"
                        @keydown.esc="handleCloseDialog"
                    >
                        <CompassIconButton
                            class="recap-dialog__close"
                            data-bot="recap-dialog__close"
                            icon="close"
                            @click="handleCloseDialog"
                        />
                        <h2 class="recap-dialog__title">
                            {{ $t.__('recap.slider.IntroductionSlide.title') }}
                        </h2>
                        <img
                            src="/ressources/logged/img/illustrations/recap2024/shape-recap.svg"
                            class="recap-dialog__image"
                            width="277"
                        />
                        <CompassButton
                            :label="$t.__('recap.RecapDialog.button')"
                            type="secondary-contrast"
                            size="large"
                            @click="goToRecap"
                        />
                    </div>
                </Transition>
            </div>
        </div>
    </Transition>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localValue: false,
            openModal: false,
        };
    },
    watch: {
        visible: {
            handler(newValue) {
                this.$nextTick(() => {
                    // Append Dialog to body Node
                    if (newValue) {
                        document.querySelector('body').appendChild(this.$el);
                    }

                    // Handle localValue (to manage descending animations) + close emit event
                    if (newValue) {
                        this.localValue = true;
                        this.$refs.modal.focus();
                    } else {
                        this.openModal = false;
                        this.$emit('closed');
                    }
                    // Handle body scroll
                    if (!this.bodyScroll) {
                        const bodyElement = document.querySelector('body');
                        if (newValue) {
                            bodyElement.style.overflow = 'hidden';
                            bodyElement.style.height = '100%';
                        } else {
                            bodyElement.style.overflow = '';
                            bodyElement.style.height = '';
                        }
                    }
                });
            },
            immediate: true,
        },
        localValue(newValue) {
            // Focus on overlay right before modal appears (to control closing with escape key)
            if (newValue) {
                this.$refs.overlay.focus();
            }
        },
    },
    mounted() {
        if (this.visible) {
            this.localValue = true;
        }
    },
    methods: {
        handleOpenModal() {
            this.openModal = true;
            this.$emit('opened');
        },
        handleCloseDialog(isOverlay = false) {
            if (isOverlay === true && !this.closeOnClickOverlay) {
                return;
            }
            this.localValue = false;
            this.$emit('update:visible', !this.visible);

            localStorage.setItem('canShowRecapDialog', false);
        },
        goToRecap() {
            this.handleCloseDialog();
            this.$nextTick(() => {
                this.$router.push({ name: 'recap2024' });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.recap-dialog {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 9999;

    &__overlay {
        background-color: rgba(0, 5, 25, 0.6);
        height: 100%;
        position: relative;
        width: 100%;
    }

    &__modal {
        align-items: center;
        background: var(--colors-common-background-darkest-default);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        height: 528px;
        justify-content: center;
        left: 50%;
        overflow: hidden;
        padding: 0 70px;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 378px;
    }

    &__close {
        color: #fff;
        position: absolute;
        right: 14px;
        top: 8px;
    }

    &__title {
        color: #fff;
        font-family: var(--font-families-stack-sans-text), sans-serif;
        font-size: 71px;
        font-weight: 400;
        margin: 0;
        position: relative;
        z-index: 1;
    }

    &__image {
        bottom: -2px;
        left: 0;
        position: absolute;
    }
}

/* TRANSITIONS */
.recap-dialog-transition-enter,
.recap-dialog-transition-leave-to {
    opacity: 0;
}
.recap-dialog-transition-enter-active,
.recap-dialog-transition-leave-active {
    transition: opacity 100ms linear;
}

.recap-dialog-modal-transition-enter {
    transform: translate(-50%, -40%);
}
.recap-dialog-modal-transition-enter-active {
    transition: transform 500ms ease-out;
}
</style>
